<template>
	<footer class="the-footer flex-wrap justify-between" :class="classes">
		<p>
			<span>&copy;</span>
			<span>{{ new Date().getFullYear() }} </span>
			<a href="https://servinformacion.com" target="_blank" rel="nofollow">Servinformaci&oacute;n</a>
			<span class="hidden sm:inline-block">, All rights Reserved</span>
		</p>
		<span class="md:flex hidden items-center">
			<span>Hand-crafted & Made with</span>
			<feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
			<span>&nbsp;V. {{ version }}</span>
		</span>
	</footer>
</template>

<script>
import {VERSION} from "@/constants";
export default {
	name: "the-footer",
	props: {
		classes: {
			type: String,
		},
	},
	data() {
		return {
			version: VERSION,
		};
	},
};
</script>
